// Run a callback during browser idle time, falling back to a near-immediate
// timeout where requestIdleCallback is unavailable (Safari). Keeps heavy,
// non-urgent work (slider/section init, third-party setup) off the frame that
// triggered it so the interaction can paint first.
//
// Note: the `timeout` only bounds the requestIdleCallback path. The Safari
// fallback ignores it and runs the callback ASAP after the current task
// (~next tick), which for our defer-off-the-frame use cases is the desired
// behaviour — do not rely on `timeout` as a guaranteed minimum delay.
export const whenIdle = (fn, timeout = 2000) =>
    (window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); })(
        fn,
        { timeout }
    );
